import styled from 'shared/utils/styled';

export const Container = styled('div')(() => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'flex-start',
  padding: 15,
  background: 'rgba(34, 64, 96, 0.06)',
}));

export const Content = styled('div')(() => ({
  marginLeft: 10,
}));

export const Description = styled('p')(() => ({
  margin: 0,
  padding: 0,
  fontSize: 14,
  fontWeight: 400,
}));

export const Link = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
}));
